module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-310x310-72a65df1cd87a51549a3b8d9ec7e534e.png";